import { Box, Card, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FormType } from '@/api/enum/formType.enum';
import { useState } from 'react';
import InformationInfoForm from './components/InformationInfoForm';

export default function InformationCreatePage() {
	const { t } = useTranslation();
	const [type, setType] = useState<FormType>(FormType.create);
	return (
		<>
			<Box sx={{ width: '100%' }}>
				<Box>
					<Typography variant='h4'>
						{t('drawerListItems.addInformation')}
					</Typography>
					<Card sx={{ marginTop: 3 }}>
						<InformationInfoForm type={type} setType={setType} />
					</Card>
				</Box>
			</Box>
		</>
	);
}
